import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import Modal from './Modal';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import Checkbox from '../forms/inputs/Checkbox';

function CancellationPolicy({ t, onClose }) {
  const [checked, setChecked] = useState(false);
  const handleCheckbox = useCallback(() => setChecked(prevState => !prevState), [setChecked]);
  const handleClose = cancel => {
    onClose(cancel);
  };
  return (
    <Modal onClose={() => handleClose(false)} id="cancellationModal">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <ModalHeader title={t('modal.cancellation.policy.title')} onClose={() => handleClose(false)} />
          <div
            id="modalBody"
            className="modal-body"
            style={{ maxHeight: '70vh', overflowY: 'auto' }}
          >
            <Checkbox
              id="checked"
              name="checked"
              label={
                <p>
                  {`${t('cancellation.policy.terms')} `}
                  <a href="/cancellation-policy" target="_blank" rel="noreferrer">
                    {`${t('landing.cancellation.policy')}.`}
                  </a>
                </p>
              }
              value={checked}
              onChange={() => handleCheckbox()}
            />
          </div>
          <ModalFooter
            onCancel={() => handleClose(false)}
            onSave={() => handleClose(true)}
            saveText={t('ok')}
            cancelText={t('cancel')}
            disabled={!checked}
          />
        </div>
      </div>
    </Modal>
  );
}

CancellationPolicy.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
CancellationPolicy.defaultProps = {
};

export default translate(CancellationPolicy);
